import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  CalendarFull,
  Cart,
  Envelope,
  InterlibraryLoans,
  Angle,
  QuestionMarkSquared
} from '@bibliocommons/deprecated-base-icons';

import './DidNotFindServiceItem.scss';

const mapIcon = service => {
  switch (service) {
    case 's4p':
      return <Cart />;
    case 'bookAnAppt':
      return <CalendarFull />;
    case 'contactUs':
      return <Envelope />;
    case 'interLibraryLoans':
      return <InterlibraryLoans />;
    case 'askAQuestion':
      return <QuestionMarkSquared />;
    default:
      return null;
  }
};

export default class DidNotFindServiceItem extends React.PureComponent {
  render() {
    const { className, serviceId, serviceName, serviceLink } = this.props;
    return (
      <li className={`service-item ${className}`}>
        {mapIcon(serviceId)}
        <a className={`did-not-find-service-link-${serviceId}`} href={serviceLink}>
          <FormattedMessage id={`${serviceName}`} />
          <Angle.Right />
        </a>
      </li>
    );
  }
}

DidNotFindServiceItem.propTypes = {
  className: PropTypes.string,
  serviceId: PropTypes.string,
  serviceName: PropTypes.string,
  serviceLink: PropTypes.string
};
